<template>
  <page :title="title">
              <message :messages="messages"></message>
                <v-layout row wrap>
                    <v-expansion-panels v-model="panels" multiple>
                      <v-expansion-panel>
                        <v-expansion-panel-header>
                          <div>
                            <v-icon>mdi-filter-variant</v-icon> Date Range
                          </div>
                        </v-expansion-panel-header>
                        <v-expansion-panel-content>
                          <v-card>
                            <v-card-text>
                              <v-container fluid grid-list-lg>
                                <v-layout row wrap>
                  <v-flex xs12 sm6>
                    <cal-picker
                      v-model="xolForm.tranDate"
                      :label="labels.tranDate"
                      :data-vv-as="labels.tranDate"
                      data-vv-name="tranDate"
                      :error-messages="errors.collect('tranDate')"
                      v-validate="'required'"
                    />
                  </v-flex>
                                </v-layout>
                              </v-container>
                            </v-card-text>
                            <v-card-actions> </v-card-actions>
                          </v-card>
                        </v-expansion-panel-content>
                      </v-expansion-panel>
                    </v-expansion-panels>
                  <v-flex xs12 class="mt-3">
                    <v-expansion-panels v-model="panels" multiple>
                      <v-expansion-panel>
                        <v-expansion-panel-header>
                          <div>
                            <v-icon>mdi-filter-variant</v-icon> Selection Criteria
                          </div>
                        </v-expansion-panel-header>
                        <v-expansion-panel-content>
                          <v-card>
                            <v-card-text>
                              <v-container fluid grid-list-lg>
                                <v-layout row wrap>
                                  <v-flex xs12 sm6>
                                    <v-autocomplete
                                      :items="inputOptions"
                                      v-model="xolForm.clmNo"
                                      :label="labels.clmNo"
                                      v-validate="'required'"
                                      item-text="label"
                                      item-value="value"
                                      data-vv-name="clmNo"
                                      :data-vv-as="labels.clmNo"
                                      :error-messages="errors.collect('clmNo')"
                                    />
                                  </v-flex>
                                  <v-flex xs12 sm6>
                                    <v-text-field
                                      v-if="xolForm.clmNo === 'selected'"
                                      v-model="xolForm.selectedClmNo"
                                      :label="labels.selectedClmNo"
                                      data-vv-name="selectedClmNo"
                                      :data-vv-as="labels.selectedClmNo"
                                      :error-messages="errors.collect('selectedClmNo')"
                                      v-validate="'required'"
                                    >
                                      <v-slide-x-reverse-transition mode="out-in" slot="append-outer">
                                        <v-icon color="info" @click="showClaimHelpList = true" v-text="'mdi-magnify'" />
                                      </v-slide-x-reverse-transition>
                                    </v-text-field>
                                  </v-flex>
                                  <v-flex xs12 sm6>
                                    <v-text-field
                                      v-model="xolForm.clmEvent"
                                      :label="labels.clmEvent"
                                      data-vv-name="clmEvent"
                                      :data-vv-as="labels.clmEvent"
                                      :error-messages="errors.collect('clmEvent')"
                                    />
                                  </v-flex>
                                  <v-flex xs12 sm6> </v-flex>
                                  <v-flex xs12 sm6>
                                    <v-autocomplete
                                      :items="inputOptions"
                                      v-model="xolForm.dept"
                                      :label="labels.dept"
                                      v-validate="'required'"
                                      item-text="label"
                                      item-value="value"
                                      data-vv-name="dept"
                                      :data-vv-as="labels.dept"
                                      :error-messages="errors.collect('dept')"
                                    />
                                  </v-flex>
                                  <v-flex xs12 sm6>
                                    <v-text-field
                                      v-if="xolForm.dept === 'selected'"
                                      v-model="xolForm.selectedDept"
                                      :label="labels.selectedDept"
                                      data-vv-name="selectedDept"
                                      :data-vv-as="labels.selectedDept"
                                      :error-messages="errors.collect('selectedDept')"
                                      v-validate="'required'"
                                    >
                                      <v-slide-x-reverse-transition mode="out-in" slot="append-outer">
                                        <v-icon color="info" @click="showDeptHelpList = true" v-text="'mdi-magnify'" />
                                      </v-slide-x-reverse-transition>
                                    </v-text-field>
                                  </v-flex>
                                  <v-flex xs12 sm6>
                                    <v-autocomplete
                                      :items="inputOptions"
                                      v-model="xolForm.branch"
                                      :label="labels.branch"
                                      v-validate="'required'"
                                      item-text="label"
                                      item-value="value"
                                      data-vv-name="branch"
                                      :data-vv-as="labels.branch"
                                      :error-messages="errors.collect('branch')"
                                    />
                                  </v-flex>
                                  <v-flex xs12 sm6>
                                    <v-text-field
                                      v-if="xolForm.branch === 'selected'"
                                      v-model="xolForm.selectedBranch"
                                      :label="labels.selectedBranch"
                                      data-vv-name="selectedBranch"
                                      :data-vv-as="labels.selectedBranch"
                                      :error-messages="errors.collect('selectedBranch')"
                                      v-validate="'required'"
                                    >
                                      <v-slide-x-reverse-transition mode="out-in" slot="append-outer">
                                        <v-icon color="info" @click="showBranchHelpList = true" v-text="'mdi-magnify'" />
                                      </v-slide-x-reverse-transition>
                                    </v-text-field>
                                  </v-flex>
                                  <v-flex xs12 sm6>
                                    <v-autocomplete
                                      :items="inputOptions"
                                      v-model="xolForm.fund"
                                      :label="labels.fund"
                                      v-validate="'required'"
                                      item-text="label"
                                      item-value="value"
                                      data-vv-name="fund"
                                      :data-vv-as="labels.fund"
                                      :error-messages="errors.collect('fund')"
                                    />
                                  </v-flex>
                                  <v-flex xs12 sm6>
                                    <v-text-field
                                      v-if="xolForm.fund === 'selected'"
                                      v-model="xolForm.selectedFund"
                                      :label="labels.selectedFund"
                                      data-vv-name="selectedFund"
                                      :data-vv-as="labels.selectedFund"
                                      :error-messages="errors.collect('selectedFund')"
                                      v-validate="'required'"
                                    >
                                      <v-slide-x-reverse-transition mode="out-in" slot="append-outer">
                                        <v-icon color="info" @click="showFundHelpList = true" v-text="'mdi-magnify'" />
                                      </v-slide-x-reverse-transition>
                                    </v-text-field>
                                  </v-flex>
                                </v-layout>
                              </v-container>
                            </v-card-text>
                            <v-card-actions> </v-card-actions>
                          </v-card>
                        </v-expansion-panel-content>
                      </v-expansion-panel>
                    </v-expansion-panels>
                  </v-flex>
                  <v-btn color="primary" @click.prevent="doSubmit" :loading="loading" class="mt-3">
                  {{ labels.generate }}
                  <v-icon right>mdi-content-save</v-icon>
                </v-btn>
                </v-layout>
    <v-dialog v-model="showClaimHelpList" width="1080px">
      <claim-help-list @close="showClaimHelpList = false" @assign-claim-no="assignClaim"></claim-help-list>
    </v-dialog>
    <v-dialog v-model="showDeptHelpList" width="1080px">
      <dept-help-list @close="showDeptHelpList = false" @assign-dept="assignDept"></dept-help-list>
    </v-dialog>
    <v-dialog v-model="showBranchHelpList" width="1080px">
      <branch-help-list @close="showBranchHelpList = false" @assign-branch="assignBranch"></branch-help-list>
    </v-dialog>
    <v-dialog v-model="showFundHelpList" width="1080px">
      <fund-help-list @close="showFundHelpList = false" @assign-fund="assignFund"></fund-help-list>
    </v-dialog>

    <v-dialog v-model="promptExeJob" width="500px" persistent>
      <batch-job-scheduler
        v-if="promptExeJob"
        :skipValidate="batchForm.skipValidate"
        :jobKeys="xolForm"
        :showJobMode="false"
        @close="promptExeJob = false"
        @doPopulate="processBatch($event)"
      />
    </v-dialog>

    <warning v-model="promptResubmit" @ok="doAccept">
      <div>{{ warningMsg1 }}</div>
      <div class="queryValue" v-for="(item, index) in bchJobDetails" :key="index">{{ item }}</div>
      <div>{{ warningMsg2 }}</div>
    </warning>
  </page>
</template>
<script>
import MessageMixin from '@/mixins/message'
import ClaimHelpList from '@/components/core/common/dialog/ClaimHelpList'
import DeptHelpList from '@/components/core/common/dialog/DeptHelpList'
import FundHelpList from '@/components/core/common/dialog/FundHelpList'
import BranchHelpList from '@/components/core/common/dialog/BranchHelpList'
// import { expandURI } from '@/utils/ajax'
import BatchJobScheduler from '@/components/core/common/BatchJobScheduler'
import { batchManagerMixin } from '@/mixins/common/batchManagerMixin'

export default {
  data() {
    return {
      title: 'Process XOL Recoveries',
      loading: false,
      showClaimHelpList: false,
      showDeptHelpList: false,
      showBranchHelpList: false,
      showFundHelpList: false,
      xolForm: {
        tranDate: undefined,
        clmNo: 'all',
        selectedClmNo: undefined,
        clmEvent: undefined,
        selectedClmEvent: undefined,
        dept: 'all',
        selectedDept: undefined,
        branch: 'all',
        selectedBranch: undefined,
        fund: 'all',
        selectedFund: undefined
      },
      labels: {
        generate: 'Generate XOL Recoveries',
        tranDate: 'Transaction Date*',
        clmNo: 'Claim No.',
        selectedClmNo: 'Selected Claim No.',
        clmEvent: 'Claim Event No.',
        dept: 'Department',
        selectedDept: 'Selected Department',
        branch: 'Branch',
        selectedBranch: 'Selected Branch',
        fund: 'Fund',
        selectedFund: 'Selected Fund'
      },
      inputOptions: [
        { label: 'All', value: 'all' },
        { label: 'Selected', value: 'selected' }
      ],
      panels: [0]
    }
  },
  methods: {
    async doInit() {},
    assignClaim(clmNo) {
      this.xolForm.selectedClmNo = clmNo
      this.showClmNoHelpList = false
      this.$validator.validate('selectedClmNo')
    },
    assignDept(dept) {
      this.xolForm.selectedDept = dept
      this.showDeptHelpList = false
      this.$validator.validate('selectedDept')
    },
    assignFund(fund) {
      this.xolForm.selectedFund = fund
      this.showFundHelpList = false
      this.$validator.validate('selectedFund')
    },
    assignBranch(branch) {
      this.xolForm.selectedBranch = branch
      this.showBranchHelpList = false
      this.$validator.validate('selectedBranch')
    },
    doSubmit() {
      this.promptResubmit = false
      this.resetMessages()
      this.$validator.validateAll().then((result) => {
        if (result) {
          if (this.isBatchManager === true) {
            this.promptExeJob = true
          } else {
            this.doGenerate()
          }
        }
      })
    },
    async doGenerate() {
      const apiURL = this.menu.generateXOLRecoveries
      if (apiURL) {
        try {
          this.loading = true
          const result = await this.$http.post(apiURL, this.xolForm)
          if (result) {
            this.$toast.success('Generating XOL Recoveries')
          }
        } catch (e) {
          this.$toast.error('Failed to start procedure')
        }
        this.loading = false
      } else {
        this.errorMessage('Error: Missing API URL')
      }
    },
    async processBatch(bmgForms) {
      const apiURI = this.menu.exeGenerateXOLRecoveries
      if (apiURI) {
        try {
          this.submitting = true
          const result = await this.$http.post(apiURI, bmgForms)
          if (result.data) {
            const { data } = result.data
            if (data.prevBchJobs && data.prevBchJobs.length > 0) {
              this.promptResubmit = true
              this.getBchJobDetails(data.prevBchJobs)
            }
          }
          this.submitting = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
          this.submitting = false
        }
      } else {
        this.errorMessage('The request failed because it is trying to execute an invalid API url.')
      }
      this.batchForm.skipValidate = false
    }
  },
  computed: {
    menu() {
      return this.$store.state.xolRecovery.menu
    }
  },
  watch: {},
  created() {},
  mounted() {
    this.doInit()
  },
  mixins: [MessageMixin, batchManagerMixin],
  components: {
    ClaimHelpList,
    DeptHelpList,
    BranchHelpList,
    FundHelpList,
    BatchJobScheduler
  }
}
</script>
